import { render } from "./AffiliateInvoices.vue?vue&type=template&id=cba37a04&scoped=true"
import script from "./AffiliateInvoices.vue?vue&type=script&lang=js"
export * from "./AffiliateInvoices.vue?vue&type=script&lang=js"

import "./AffiliateInvoices.vue?vue&type=style&index=0&id=cba37a04&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba37a04"]])

export default __exports__